import { render, staticRenderFns } from "./sgd.vue?vue&type=template&id=240b9d8a&scoped=true"
import script from "./sgd.vue?vue&type=script&lang=js"
export * from "./sgd.vue?vue&type=script&lang=js"
import style0 from "./sgd.vue?vue&type=style&index=0&id=240b9d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240b9d8a",
  null
  
)

export default component.exports